<section>
  <app-list-view
    [columnDefinition]="columnDefinitions"
    [contextMenuDefinition]="contextMenuDefinitions"
    [itemsSource]="items"
    [contextId]="contextId"
    [preferencesKey]="'common.connected-document-manager.list'"
  ></app-list-view>
</section>
